"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ConsultationCTA() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section ref={ref} className={`py-16 md:py-24 px-6 bg-background transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-sm font-medium text-secondary uppercase tracking-widest mb-4">
          THE NEXT STEP
        </p>
        <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6 text-primary">
          Begin by Organizing the Matter
        </h2>
        <p className="text-lg md:text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
          Existing estate documents, ownership records, beneficiary designations, relevant financial and property information, and any probate or court papers already received can help make the initial consultation more focused and productive.
        </p>
        <Button asChild className="mt-2">
          <Link to="/ContactUsPage">
            Request a Consultation
            <ArrowRight className="size-4" />
          </Link>
        </Button>
        <p className="text-xs text-muted-foreground mt-6 max-w-lg mx-auto">
          Submitting information or contacting the office does not create an attorney-client relationship. Please do not send confidential information until an attorney-client relationship has been established.
        </p>
      </div>
    </section>;
}